import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LoginPage } from "@corpuscomplete/web/modules/auth/pages/login";
import { safeRedirectPath } from "../../utils/redirect";

export const Route = createFileRoute("/_unauthenticated/login")({
  validateSearch: z.object({
    redirect: z.string().optional().transform(safeRedirectPath),
  }),
  component: LoginPage,
});
